/* global $:false */

export default class MarketLotShowCountdown {
  // ––––––––––––––
  // Initialization
  // ––––––––––––––

  constructor () {
    this.start = this.start.bind(this)
    this.update = this.update.bind(this)
    this.stop = this.stop.bind(this)
    this.shouldRun = this.shouldRun.bind(this)
    this.tick = this.tick.bind(this)
    this.updateCSS = this.updateCSS.bind(this)
    this.startStandbyProtection = this.startStandbyProtection.bind(this)
    this.standbyProtectionTick = this.standbyProtectionTick.bind(this)
    this.stopStandbyProtection = this.stopStandbyProtection.bind(this)
    this.secondsToDuration = this.secondsToDuration.bind(this)
    this.el = $('.js-market-lot-show-countdown')
    this.counter = this.el.find('.js-market-lot-show-countdown__counter')
    this.secondsLeft = this.el.data('seconds-remaining')
    this.refreshCallback = function () {}
    this.subscribeToVisibilityChanges()
  }

  // ––––––––––––––
  // Start and Stop
  // ––––––––––––––

  start () {
    this.stop()
    if (!this.shouldRun()) { return }
    this.startStandbyProtection()
    this.countdown = setInterval(() => {
      this.secondsLeft--
      this.tick()
    }, 1000)
  }

  update (secondsLeft) {
    this.secondsLeft = secondsLeft
    this.start()
  }

  stop () {
    this.stopStandbyProtection()
    clearInterval(this.countdown)
  }

  // ––––––––––––––––
  // Interval trigger
  // ––––––––––––––––

  shouldRun () {
    if (this.secondsLeft === null) { return false }
    return this.secondsLeft >= 0 && this.secondsLeft <= 3600
  }

  tick () {
    if (this.shouldRun()) {
      this.el.show()
      this.counter.html(this.secondsToDuration(this.secondsLeft))
      this.updateCSS()
    } else {
      if (this.secondsLeft < 0) { this.el.hide() }
      this.stop()
    }
  }

  updateCSS () {
    if (this.secondsLeft < 60) {
      this.el.addClass('c-market-lot-show-countdown--less-than-a-minute')
    } else {
      this.el.removeClass('c-market-lot-show-countdown--less-than-a-minute')
    }
  }

  // ––––––––––––––––––
  // Standby Protection
  // ––––––––––––––––––

  subscribeToVisibilityChanges () {
    $(document).on('visibilitychange', () => {
      if (document.visibilityState !== 'visible') { return }
      this.refreshCallback()
    })
  }

  startStandbyProtection () {
    this.dreamTicks = 0
    this.stopStandbyProtection()
    this.myNow = this.realNow()
    this.standbyProtection = setInterval(() => {
      this.standbyProtectionTick()
    }, 1000)
  }

  standbyProtectionTick () {
    const diff = this.realNow() - this.myNow
    if (diff > 1) {
      // Browser Operation is suspended (iOS) or slowed down (Mac OS App Nap)
      this.dreamTicks++
    } else if (this.dreamTicks > 0) {
      // If operation is *not* suspended (any more) but we had sweet
      // dreamTicks, we need to come back into reality at once.
      this.dreamTicks = 0
      this.refreshCallback()
    }
    this.myNow = this.realNow()
  }

  stopStandbyProtection () {
    clearInterval(this.standbyProtection)
  }

  // Returns an Integer representing the UNIX epoch seconds until now.
  realNow () {
    return parseInt(new Date().getTime() / 1000)
  }

  // ––––––––––––
  // I18n helpers
  // ––––––––––––

  localizedLessThanAMinute () {
    switch (window.gon.locale) {
      case 'sv': return 'under 1 minut'
      case 'fi': return 'alle 1 minuutti'
      default: return 'less than 1 minute'
    }
  }

  localizedMinutes (count) {
    switch (count) {
      case 1:
        switch (window.gon.locale) {
          case 'sv': return '1 minut'
          case 'fi': return '1 minuutti'
          default: return '1 minute'
        }
      default:
        switch (window.gon.locale) {
          case 'sv': return `${count} minuter`
          case 'fi': return `${count} minuuttia`
          default: return `${count} minutes`
        }
    }
  }

  localizedSeconds (count) {
    switch (count) {
      case 1:
        switch (window.gon.locale) {
          case 'sv': return '1 sekund'
          case 'fi': return '1 sekunti'
          default: return '1 second'
        }
      default:
        switch (window.gon.locale) {
          case 'sv': return `${count} sekunder`
          case 'fi': return `${count} sekuntia`
          default: return `${count} seconds`
        }
    }
  }

  // As of now, this only works below 1 hour
  secondsToDuration (time) {
    const days = Math.floor(time / 86400)
    let _rem = time - (days * 86400)
    const hours = Math.floor(_rem / 3600)
    _rem = _rem - (hours * 3600)
    const minutes = Math.floor(_rem / 60)
    const seconds = _rem - (minutes * 60)

    switch (false) {
      case !(time < 60):
        return this.localizedLessThanAMinute()
      case !(time < 3600):
        return `${this.localizedMinutes(minutes)} ${this.localizedSeconds(seconds)}`
    }
  }
}
